export const storeFavoriteClosedMarkerSvgRevamp = `
<svg width="51" height="55" viewBox="0 0 51 55" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25 5.4c-8.5 0-15.3 6.8-15.3 15.3C9.7 32 25 49 25 49s15.3-17 15.3-28.4c0-8.5-6.9-15.3-15.3-15.3Z"
        fill="#999" />
    <path
        d="m25 29.4-1.3-1c-4.5-4-7.5-6.5-7.5-9.7 0-2.6 2.1-4.6 4.8-4.6 1.6 0 3 .7 4 1.8 1-1.1 2.4-1.8 3.9-1.8 2.7 0 4.8 2 4.8 4.6 0 3.2-3 5.7-7.5 9.6L25 29.4Z"
        fill="#fff" />
</svg>
`;
